Namespace 'Customer.Filters'

class Customer.Filters.SentimentsCardView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/interactions/sentiments_card']
  className: 'filter-field-container filter-sentiment-container checkboxes'

  initialize: ({filter, sentiments, newQuery}) ->
    @filter = filter
    @sentiments = sentiments
    @newQuery = newQuery

  render: ->
    @$el.html @template({
      filter: @filter
      sentiments: @sentiments
      normalizeSentiment: @_normalizeSentiment
    })
    @

  _keepCustomerSessionAlive: ->
    Backbone.trigger 'customerSession:keepAlive'

  _onClickCheckbox: (event) =>
    @trigger('sentiments:checkbox:clicked')

  _normalizeSentiment: (sentiment) ->
    sentiment.replace(/\s+/g, '_').toLowerCase()
